/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import './bootstrap';

import {createApp} from "vue";



import {registerComponents} from './components';
import {registerMixins} from "./app-mixins";
import moment from "moment";
import CKEditor from '@ckeditor/ckeditor5-vue';
import vSelect from "vue-select";
// import "vue-select/src/scss/vue-select.scss"; // (s)css has to be included separately
import injectedData from "./injectedData";

console.log("Components: ")
const app = createApp({});

registerComponents(app)
registerMixins(app)
injectedData(app)

app.config.globalProperties.$moment = moment
app.use(CKEditor);
app.component('vSelect', vSelect);
app.mount('#app')

// Add screen reader only text for links that open in new window
document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('a[target="_blank"]').forEach(function (el) {
        let span = document.createElement('span');
        span.classList.add('visually-hidden');
        span.innerHTML = ', opens in a new window';
        el.appendChild(span);
    });
}, false);

// const files = require.context('./', true, /\.vue$/i)
// // files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))
// // OnClickOutside: defineAsyncComponent(() => import(/* webpackChunkName:"OnClickOutside" */ "./components/Base/OnClickOutside")),
// files.keys().map(path => {
//     console.log(path, ' ---- ', path.split('/').pop().split('.')[0])
//     let name = path.split('/').pop().split('.')[0];
//     console.log(`app.component('${name}', defineAsyncComponent(() => import(/* webpackChunkName:"${name}" */ "${path.replace('.vue', '')}")))`)
//     // eval(`app.component('${name}', defineAsyncComponent(() => import(/* webpackChunkName:"${name}" */ "${path}")))`)
//     app.component(name, defineAsyncComponent(() => import(path)));
//
// })


